export interface Chapter {
  id: string;
  number: number;
  title: string;
  subtitle?: string;
}

export const BOOK_INFO = {
  title: "住宅大全2026 インフレ時代の住宅購入戦略",
  subtitle: "〜条件が整った人は先送りするな。危ない物件は買うな。〜",
  author: "橋本 裕介",
  authorTitle: "株式会社TESキャピタル 代表取締役",
  publicationDate: "2026年4月",
  tagline: "",
  copyright: "© 2026 株式会社TESキャピタル",
} as const;

export const CHAPTERS: Chapter[] = [
  {
    id: "cover",
    number: 0,
    title: "表紙",
  },
  {
    id: "chapter-1",
    number: 1,
    title: "第1章：2026年、住宅購入を先送りしすぎるリスク",
  },
  {
    id: "chapter-2",
    number: 2,
    title: "第2章：インフレ時代に強い不動産・弱い不動産",
  },
  {
    id: "chapter-3",
    number: 3,
    title: "第3章：建築費高騰は新築だけの話ではない",
  },
  {
    id: "chapter-4",
    number: 4,
    title: "第4章：賃貸は自由、持ち家は資産防衛",
  },
  {
    id: "chapter-5",
    number: 5,
    title: "第5章：住宅ローンは人生の自由度を固定する",
  },
  {
    id: "chapter-6",
    number: 6,
    title: "第6章：買っていい物件・買ってはいけない物件",
  },
  {
    id: "chapter-7",
    number: 7,
    title: "第7章：インフレ時代の最終結論＋資料",
  },
  {
    id: "closing",
    number: 8,
    title: "おわりに",
  },
];

export const LINE_URL = "https://line.me/ti/p/@tes2030";

export const ROUTE_PATHS = {
  HOME: "/",
} as const;
